module.exports = __webpack_public_path__ + "static/media/neptune.f7ec6c81.svg";